import {
  Box,
  Button,
  Container,
  makeStyles,
  TextField
} from "@material-ui/core";
import { useState } from "react";
import { signInWithEmailAndPassword } from "@firebase/auth";
import { auth } from "../firebase";
import { CryptoState } from "../CryptoContext";

const useStyles = makeStyles(() => ({
  loginContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px"
  }
}));

function Login({ handleClose }) {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { setAlert } = CryptoState();

  const handleSubmit = async () => {
    if (!email || !password) {
      setAlert({
        open: true,
        message: "Please fill all fields",
        type: "error"
      });
      return;
    }

    try {
      const result = await signInWithEmailAndPassword(auth, email, password);

      setAlert({
        open: true,
        message: `Login succesful.  Welcome ${result.user.email}`,
        type: "success"
      });

      handleClose();
    } catch (error) {
      setAlert({
        open: true,
        message: error.message,
        type: "error"
      });
    }
  };

  return (
    <Box p={3} className={classes.loginContainer}>
      <TextField
        variant="outlined"
        type="email"
        label="Enter Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        fullWidth
      />
      <TextField
        variant="outlined"
        type="password"
        label="Enter Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
      />

      <Button
        variant="contained"
        size="large"
        style={{ backgroundColor: "#eebc1d" }}
        onClick={handleSubmit}
      >
        login
      </Button>
    </Box>
  );
}

export default Login;
